import { URI } from '@/config/config'

export default async ({ rootState }, { payload, userId }) => {
  const opts = {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken
    },
    body: JSON.stringify(payload)
  }

  const userLoginInfoResult = await fetch(`${URI}control-panel/employee/${userId}`, opts)
  const jsonResult = await userLoginInfoResult.json()

  if (jsonResult.status === 'fail') {
    return Promise.reject(jsonResult.message)
  }

  return jsonResult.create
}